module.exports = __webpack_public_path__ + "static/noise-bf1401ae5f2f12fb4f6125bcb5b5e58d.png";